import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/machines/machineDetailsHeader.css';

const MachineNoteDetailsHeader = () => {

    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const user = useSelector((state) => state?.AuthenticatedUser);
    const machineNoteDetailsData = useSelector((state) => state.MachineNoteDetailsData);

    const hasMachineUpdatePermission = useHasPermission('machine_update');

    const [errMsg, setErrMsg] = useState('');
    const [deleteNote, setDeleteNote] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDelete = async () => {
        try {
            const response = await axios.delete(`machine-note/${machineNoteDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                navigate(`/dashboard/machines/machine_details/${machineNoteDetailsData?.machine_id}`, { state: '5' });
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error?.response?.data?.message || 'Erreur lors de la suppression du remarque');
            console.error('Erreur lors de la suppression du remarque :', error);
            CustomErrorLogger(error, 'Erreur lors de la suppression du remarque');
        }
    }

    const updateNoteStatus = async (status) => {
        try {
            const response = await axios.patch(`machine-note/updateNoteStatus/${machineNoteDetailsData.id}`, { status });
            if (response.status === 200 || response.status === 201) {
                navigate(`/dashboard/machines/machine_details/${machineNoteDetailsData?.machine_id}`, { state: '5' });
            }
        } catch (error) {
            console.error('Erreur lors de modifier la statut de la remarque :', error);
            CustomErrorLogger(error, 'Erreur lors de modifier la statut de la remarque');
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = useCallback(() => {
        navigate(`/dashboard/machines/machine_details/${machineNoteDetailsData?.machine_id}`, { state: '5' });
    }, [navigate, machineNoteDetailsData?.machine_id]);

    return (
        <Box className="MachineDetailsHeader_mainBox">
            <Box className="MachineDetailsHeader_firstPart">
                <Iconify className='MachineDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="MachineDetailsHeader_title">Consulter la remarque</Typography>
            </Box>
            {!machineNoteDetailsData?.machine?.is_archived &&
                <Box className="MachineDetailsHeader_secondPart">
                    {(isDesktop && machineNoteDetailsData?.status === 'Active' && hasMachineUpdatePermission) &&
                        <Box className="MachineDetailsHeader_action_box" onClick={() => updateNoteStatus('Annulee')}>
                            <Iconify className='MachineDetailsHeader_copy_icon' icon={"ix:cancel"} />
                            <Typography className="MachineDetailsHeader_copy_title">Annulée</Typography>
                        </Box>
                    }
                    {(isDesktop && machineNoteDetailsData?.status === 'Active' && hasMachineUpdatePermission) &&
                        <Box className="MachineDetailsHeader_action_box" onClick={() => updateNoteStatus('Prise_en_compte')}>
                            <Iconify className='MachineDetailsHeader_copy_icon' sx={{ color: '#309129 !important' }} icon={"solar:archive-minimalistic-outline"} />
                            <Typography className="MachineDetailsHeader_copy_title" sx={{ color: '#309129 !important' }}>Prise en compte</Typography>
                        </Box>
                    }
                    {(isDesktop && (hasMachineUpdatePermission || (user?.id === machineNoteDetailsData?.created_by?.id && machineNoteDetailsData?.status === 'Active'))) &&
                        <Box className="MachineDetailsHeader_action_box" onClick={() => setDeleteNote(true)}>
                            <Iconify className='MachineDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="MachineDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </Box>
                    }
                    {!isDesktop && <Iconify
                        className='MachineDetailsHeader_dots_icon'
                        icon={"vaadin:ellipsis-dots-v"}
                        id="userPageActionMenuIcom"
                        aria-controls={openActionMenu ? 'long-menu' : undefined}
                        aria-expanded={openActionMenu ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleOpenActionMenu}
                    />}
                    <Menu
                        id="usersePageActionMenu"
                        MenuListProps="usersPageActionMenuIcom"
                        open={openActionMenu}
                        anchorEl={anchorEl}
                        onClose={handleCloseActionMenu}
                        onClick={handleCloseActionMenu}
                        slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                    >
                        {(!isDesktop && machineNoteDetailsData?.status === 'Active' && hasMachineUpdatePermission) &&
                            <MenuItem className='MachineDetailsHeader_menuItem' onClick={() => updateNoteStatus('Annulee')}>
                                <Iconify className='MachineDetailsHeader_copy_icon' icon={"ix:cancel"} />
                                <Typography className="MachineDetailsHeader_copy_title">Annulée</Typography>
                            </MenuItem>
                        }
                        {(!isDesktop && machineNoteDetailsData?.status === 'Active' && hasMachineUpdatePermission) &&
                            <MenuItem className='MachineDetailsHeader_menuItem' onClick={() => updateNoteStatus('Prise_en_compte')}>
                                <Iconify className='MachineDetailsHeader_copy_icon' icon={"solar:archive-minimalistic-outline"} />
                                <Typography className="MachineDetailsHeader_copy_title">Prise en compte</Typography>
                            </MenuItem>
                        }
                        {(!isDesktop && (hasMachineUpdatePermission || (user?.id === machineNoteDetailsData?.created_by?.id && machineNoteDetailsData?.status === 'Active'))) &&
                            <MenuItem className='MachineDetailsHeader_menuItem' onClick={() => setDeleteNote(true)}>
                                <Iconify className='MachineDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                                <Typography className="MachineDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                            </MenuItem>
                        }
                    </Menu>
                </Box>
            }
            {deleteNote &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteNote}
                    setOpenDelete={setDeleteNote}
                    handleDelete={handleDelete}
                    title='Êtes-vous sûr de vouloir supprimer cette remarque ?'
                />
            }
        </Box>
    );
}

export default MachineNoteDetailsHeader;